import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Deutsche Übersetzungen
import deCommon from './locales/de/common.json';
import deNavbar from './locales/de/navbar.json';
import deUpload from './locales/de/upload.json';
import deProviders from './locales/de/providers.json';
import deAdmin from './locales/de/admin.json';
import deQs from './locales/de/qs.json';
import deSettings from './locales/de/settings.json';
import deDashboard from './locales/de/dashboard.json';

// Englische Übersetzungen
import enCommon from './locales/en/common.json';
import enNavbar from './locales/en/navbar.json';
import enUpload from './locales/en/upload.json';
import enProviders from './locales/en/providers.json';
import enAdmin from './locales/en/admin.json';
import enQs from './locales/en/qs.json';
import enSettings from './locales/en/settings.json';
import enDashboard from './locales/en/dashboard.json';

// Französische Übersetzungen
import frCommon from './locales/fr/common.json';
import frNavbar from './locales/fr/navbar.json';
import frUpload from './locales/fr/upload.json';
import frProviders from './locales/fr/providers.json';
import frAdmin from './locales/fr/admin.json';
import frQs from './locales/fr/qs.json';
import frSettings from './locales/fr/settings.json';
import frDashboard from './locales/fr/dashboard.json';

// Italienische Übersetzungen
import itCommon from './locales/it/common.json';
import itNavbar from './locales/it/navbar.json';
import itUpload from './locales/it/upload.json';
import itProviders from './locales/it/providers.json';
import itAdmin from './locales/it/admin.json';
import itQs from './locales/it/qs.json';
import itSettings from './locales/it/settings.json';
import itDashboard from './locales/it/dashboard.json';

// Spanische Übersetzungen
import esCommon from './locales/es/common.json';
import esNavbar from './locales/es/navbar.json';
import esUpload from './locales/es/upload.json';
import esProviders from './locales/es/providers.json';
import esAdmin from './locales/es/admin.json';
import esQs from './locales/es/qs.json';
import esSettings from './locales/es/settings.json';
import esDashboard from './locales/es/dashboard.json';

// Russische Übersetzungen
import ruCommon from './locales/ru/common.json';
import ruNavbar from './locales/ru/navbar.json';
import ruUpload from './locales/ru/upload.json';
import ruProviders from './locales/ru/providers.json';
import ruAdmin from './locales/ru/admin.json';
import ruQs from './locales/ru/qs.json';
import ruSettings from './locales/ru/settings.json';
import ruDashboard from './locales/ru/dashboard.json';

// Polnische Übersetzungen
import plCommon from './locales/pl/common.json';
import plNavbar from './locales/pl/navbar.json';
import plUpload from './locales/pl/upload.json';
import plProviders from './locales/pl/providers.json';
import plAdmin from './locales/pl/admin.json';
import plQs from './locales/pl/qs.json';
import plSettings from './locales/pl/settings.json';
import plDashboard from './locales/pl/dashboard.json';

// Niederländische Übersetzungen
import nlCommon from './locales/nl/common.json';
import nlNavbar from './locales/nl/navbar.json';
import nlUpload from './locales/nl/upload.json';
import nlProviders from './locales/nl/providers.json';
import nlAdmin from './locales/nl/admin.json';
import nlQs from './locales/nl/qs.json';
import nlSettings from './locales/nl/settings.json';
import nlDashboard from './locales/nl/dashboard.json';

const resources = {
  de: {
    common: deCommon,
    navbar: deNavbar,
    upload: deUpload,
    providers: deProviders,
    admin: deAdmin,
    qs: deQs,
    settings: deSettings,
    dashboard: deDashboard,
  },
  en: {
    common: enCommon,
    navbar: enNavbar,
    upload: enUpload,
    providers: enProviders,
    admin: enAdmin,
    qs: enQs,
    settings: enSettings,
    dashboard: enDashboard,
  },
  fr: {
    common: frCommon,
    navbar: frNavbar,
    upload: frUpload,
    providers: frProviders,
    admin: frAdmin,
    qs: frQs,
    settings: frSettings,
    dashboard: frDashboard,
  },
  it: {
    common: itCommon,
    navbar: itNavbar,
    upload: itUpload,
    providers: itProviders,
    admin: itAdmin,
    qs: itQs,
    settings: itSettings,
    dashboard: itDashboard,
  },
  es: {
    common: esCommon,
    navbar: esNavbar,
    upload: esUpload,
    providers: esProviders,
    admin: esAdmin,
    qs: esQs,
    settings: esSettings,
    dashboard: esDashboard,
  },
  ru: {
    common: ruCommon,
    navbar: ruNavbar,
    upload: ruUpload,
    providers: ruProviders,
    admin: ruAdmin,
    qs: ruQs,
    settings: ruSettings,
    dashboard: ruDashboard,
  },
  pl: {
    common: plCommon,
    navbar: plNavbar,
    upload: plUpload,
    providers: plProviders,
    admin: plAdmin,
    qs: plQs,
    settings: plSettings,
    dashboard: plDashboard,
  },
  nl: {
    common: nlCommon,
    navbar: nlNavbar,
    upload: nlUpload,
    providers: nlProviders,
    admin: nlAdmin,
    qs: nlQs,
    settings: nlSettings,
    dashboard: nlDashboard,
  },
};

export const supportedLanguages = [
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  // Temporär deaktiviert - andere Sprachen folgen später
  // { code: 'fr', name: 'Français', flag: '🇫🇷' },
  // { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  // { code: 'es', name: 'Español', flag: '🇪🇸' },
  // { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  // { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  // { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    supportedLngs: ['de', 'en', 'fr', 'it', 'es', 'ru', 'pl', 'nl'],
    ns: ['common', 'navbar', 'upload', 'providers', 'admin', 'qs', 'settings', 'dashboard'],
    defaultNS: 'common',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: false, // Avoid suspense issues with SSR
    },
  });

export default i18n;

